/** Проверяет, что аргумент - число, целое или с точкой */
export function isNumeric(obj) {
  obj = String(obj);
  return !isNaN(parseFloat(obj)) && isFinite(obj);
}
